function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.137 20A3.868 3.868 0 0020 16.137V9.863A3.868 3.868 0 0016.137 6H9.863A3.868 3.868 0 006 9.863v6.274A3.868 3.868 0 009.863 20h6.274zm-5.502-7.117c0-1.24 1.06-2.248 2.365-2.248 1.305 0 2.365 1.008 2.365 2.248 0 1.24-1.061 2.248-2.365 2.248-1.304 0-2.365-1.009-2.365-2.248zm6.768-2.988a.92.92 0 01-.644.267.916.916 0 01-.91-.912.913.913 0 011.554-.644.914.914 0 010 1.289zM13 16.608A3.612 3.612 0 019.393 13 3.612 3.612 0 0113 9.393 3.611 3.611 0 0116.607 13 3.611 3.611 0 0113 16.608zm5.758-6.744a2.624 2.624 0 00-2.622-2.622H9.864a2.625 2.625 0 00-2.622 2.622v6.273a2.624 2.624 0 002.622 2.62h6.272a2.624 2.624 0 002.622-2.62V9.864z",
  fill: "#fff"
});

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram.e42aa24f.svg";
export { ForwardRef as ReactComponent };